import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "公司产品"
          },
          children: [
            {
              path: "/software",
              redirect: "/software/productIntroduction"
            },
            {
              path: "/software/productIntroduction",
              name: "software",
              component: resolve =>
                require(["@/view/Software_productIntroduction"], resolve),
              meta: {
                title: "公司产品丨产品介绍"
              }
            },
            {
              path: "/software/applicationScenario",
              name: "software",
              component: resolve =>
                require(["@/view/Software_applicationScenario"], resolve),
              meta: {
                title: "公司产品丨应用场景"
              }
            },
            {
              path: "/software/success",
              name: "software",
              component: resolve =>
                require(["@/view/Software_success"], resolve),
              meta: {
                title: "公司产品丨成功案例"
              }
            },
            {
              path: "/software/intelligentGateway",
              name: "software",
              component: resolve =>
                require(["@/view/Software_intelligentGateway"], resolve),
              meta: {
                title: "公司产品丨产品介绍"
              }
            },
            {
              path: "/software/internetOfThings",
              name: "software",
              component: resolve =>
                require(["@/view/Software_internetOfThings"], resolve),
              meta: {
                title: "公司产品丨产品介绍"
              }
            },
            {
              path: "/software/intelligentCloud",
              name: "software",
              component: resolve =>
                require(["@/view/Software_intelligentCloud"], resolve),
              meta: {
                title: "公司产品丨产品介绍"
              }
            },
            {
              path: "/software/smartCity",
              name: "software",
              component: resolve =>
                require(["@/view/Software_smartCity"], resolve),
              meta: {
                title: "公司产品丨产品介绍"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        // path: "/software",
        // name: "software",
        // component: resolve => require(["@/view/Software"], resolve),
        // meta: {
        //   title: "公司产品"
        // },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "公司产品"
          }
        },
        {
          path: "/goToNewsDetails",
          name: "goToNewsDetails",
          component: resolve => require(["@/view/goToNewsDetails"], resolve),
          meta: {
            title: "新闻动态"
          }
        }
      ]
    }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js